import { render, staticRenderFns } from "./SignupSelector.vue?vue&type=template&id=fff29b38&scoped=true&"
import script from "./SignupSelector.vue?vue&type=script&lang=js&"
export * from "./SignupSelector.vue?vue&type=script&lang=js&"
import style0 from "./SignupSelector.vue?vue&type=style&index=0&id=fff29b38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff29b38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VBtn,VCol,VContainer,VRow})
